import API from 'utils/api';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/catalogos/porcentajes-vehiculares/';

/**
 * GET Porcentajes Vehiculares
 * @returns {Promise<Array<object>>}
 */
export const getPorcentajesVehiculares = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Porcentaje Vehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getPorcentajeVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Porcentaje Vehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPorcentajeVehicular = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Porcentaje Vehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPorcentajeVehicular = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Porcentaje Vehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deletePorcentajeVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
